import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { IActivityType } from '../../locks-type';

@Component({
  selector: 'app-lock-types',
  templateUrl: './lock-types.component.html',
  styleUrls: ['./lock-types.component.scss'],
})
export class LockTypesComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() formGroupIdName!: string;
  @Input() entityType!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() activityTypes: IActivityType[] = [];

  formGroup!: FormGroup;
  entityTypeForm!: FormGroup;
  submited = false;
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  holdPreviousState!: string[];

  constructor(public rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.entityTypeForm = this.rootFormGroup.control.get(
      this.formGroupIdName
    ) as FormGroup;
    this.holdPreviousState = this.formGroup.controls?.eventType?.value;
    this.updateForm(this.holdPreviousState);
  }

  /**
   * @description validate form if form valid hold value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    this.submited = true;
    this.updateForm(
      this.activityTypes!.filter(
        (activityType: IActivityType) => activityType.active
      )?.map((activityType: IActivityType) => activityType.eventType)
    );

    this.updateIds(
      this.activityTypes!.filter(
        (activityType: IActivityType) => activityType.active
      )?.map((activityType: IActivityType) => activityType?.eventCode)
    );
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description updateForm function will update the form.
   * @returns void
   */
  updateForm(lock: string[]) {
    this.formGroup.patchValue({
      eventType: lock,
    });
    this.activityTypes = this.activityTypes?.map(
      (activityType: IActivityType) => ({
        ...activityType,
        active: lock?.includes(activityType.eventType!) || false,
      })
    );
  }

  /**
   * @description updateIds function will update the ids into the list.
   * @returns void
   */
  updateIds(lockIds: (string | undefined)[]) {
    this.entityTypeForm.patchValue({
      eventTypeIds: lockIds,
    });
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.updateForm(this.holdPreviousState);
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description updateActivityType function will update active state of activities.
   * @returns void
   */
  updateActivityType(activityType: any) {
    activityType.active = !activityType.active;
  }
}
